<template>
  <div style="padding: 10px">
    <Modal v-model="isShowSetModal" :mask-closable="false" width="700">
      <p slot="header" style="text-align:center">
        <Icon type="md-create" />
        <span>显示项设置</span>
      </p>
      <!-- <tr v-for="(value, key) in stateArray" :value="value" :key="key">
          <td style="width:190px">{{key + ":"}}</td>
          <td>{{value}}</td>
      </tr>-->
      <Form label-position="left" :label-width="100" style="margin-left:20px">
        <FormItem label="展示数据">
          <Tag
            :checked="showColumnTitleArray.indexOf(item.title) > -1"
            v-for="item in columnsbackup"
            :name="item.title"
            @on-change="changeColumn"
            size="medium"
            checkable
            color="primary"
          >{{item.title}}</Tag>
        </FormItem>
      </Form>
      <div slot="footer">
        <!-- <Button type="primary" @click="true" style="margin-left: 20px;">确定</Button> -->
      </div>
    </Modal>

    <div style="background: #fff; border-radius: 8px; padding: 20px;">
      <div class="query-c">
        <Row style="white-space:nowrap;">
          <Col
            span="15"
            style="border:3px solid #57A3F3;padding:2px;margin:2px;border-radius: 25px;"
          >
            <div style="margin-left:3%;">
              <br />
              <div>
                <Select
                  clearable
                  filterable
                  placeholder="选择行政区"
                  v-model="addressfield1"
                  style="width:19%;"
                >
                  <Option
                    v-for="item in addressObject.addressfield1"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
                <Select
                  clearable
                  filterable
                  placeholder="选择小区"
                  v-model="addressfield2"
                  style="width:19%;margin-left:5px"
                >
                  <Option
                    v-if="item.pid == addressfield1"
                    v-for="item in addressObject.addressfield2"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
                <Select
                  clearable
                  filterable
                  placeholder="选择楼栋"
                  v-model="addressfield3"
                  style="width:19%;;margin-left:5px"
                >
                  <Option
                    v-if="item.pid == addressfield2"
                    v-for="item in addressObject.addressfield3"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
                <Select
                  clearable
                  filterable
                  placeholder="选择单元"
                  v-model="addressfield4"
                  style="width:19%;;margin-left:5px"
                >
                  <Option
                    v-if="item.pid == addressfield3"
                    v-for="item in addressObject.addressfield4"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
                <Select
                  clearable
                  filterable
                  placeholder="选择门牌"
                  v-model="addressfield5"
                  style="width:19%;;margin-left:5px"
                >
                  <Option
                    v-if="item.pid == addressfield4"
                    v-for="item in addressObject.addressfield5"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
                <!-- <Select filterable placeholder="选择设备地址" v-model="modalData.address" style="width:150px;;margin-left:5px">
                <Option v-for="item in meterArray" :value="item" :key="item">{{ item }}</Option>
                </Select>-->
              </div>
              <div style="margin-top:5px">
                <Input v-model="consumerNumber" style="width:19%" placeholder="输入用户编号" />
                <Input
                  v-model="consumerName"
                  style="width:19%;margin-left:5px"
                  placeholder="输入用户姓名"
                />
                <Input
                  v-model="consumerPhone"
                  style="width:19%;margin-left:5px"
                  placeholder="输入用户联系电话"
                />
                <Select
                  v-if="getUserMeterType() == undefined || getUserMeterType() == '流量计'"
                  clearable
                  v-model="meterType"
                  style="width:19%;margin-left:5px"
                  placeholder="选择设备类型"
                >
                  <Option
                    v-for="item in showOrder"
                    :value="item"
                    :key="item"
                  >{{ userMeterTypeEnum[item] }}</Option>
                </Select>
              </div>
              <div style="margin-top:5px">
                <DatePicker
                  format="yyyy-MM-dd"
                  v-model="modalData.timeRange[0]"
                  type="date"
                  split-panels
                  placeholder="选择时间"
                  style="width: 19%"
                ></DatePicker>
                <Select v-show="false" v-model="modalData.hourRange[0]" style="width:19%;margin-left: 5px;">
                  <Option v-for="item in hourList" :value="item" :key="item">{{ item }}点</Option>
                </Select>
                <DatePicker
                  format="yyyy-MM-dd"
                  v-model="modalData.timeRange[1]"
                  type="date"
                  split-panels
                  placeholder="选择时间"
                  style="width: 19%;margin-left: 5px;"
                ></DatePicker>
                <Select v-show="false" v-model="modalData.hourRange[1]" style="width:19%;margin-left: 5px;">
                  <Option v-for="item in hourList" :value="item" :key="item">{{ item }}点</Option>
                </Select>
                <!-- <Select v-model="selectMeterType" style="width:200px;margin-left: 20px;">
                <Option v-for="item in meterTList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>-->

                <Button
                  style="margin-left:49%;width: 9%;"
                  type="primary"
                  icon="ios-search"
                  @click="ok"
                  :loading="okLoading"
                >查询</Button>
              </div>
              <br />
            </div>
          </Col>
          <Col
            span="3"
            style="border:3px solid #57A3F3;padding:2px;margin:2px;border-radius: 25px;"
          >
            <div style="margin-left:15%">
              <br />
              <br />
              <Button
                type="primary"
                @click="exportTable"
                style="width:80%;margin-top:15px;margin-bottom:15px"
              >导出当前页</Button>
              <br />
              <br />
              <br />
            </div>
          </Col>
          <Col span="5" style="margin-left:35px">
            <br />
            <Button
              type="primary"
              @click="isShowSetModal = true"
              style="margin-left: 20px;float:right"
            >显示项设置</Button>
          </Col>
        </Row>
      </div>
      <br />
      <div style="height:80%;">
        <Table
          :height="tableHeight"
          :columns="columns"
          :data="tableData"
          border
          ref="table"
          highlight-row
        ></Table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "settlement",
  watch: {
    selectMeterType(newValue, oldValue) {
      let that = this;
      that.columns = that.columnsList[newValue];
    }
  },
  mounted() {
    let that = this;
    window.addEventListener("resize", function() {
      that.tableHeight = (window.innerHeight - 186) * 0.65;
    });
    that.tableHeight = (window.innerHeight - 186) * 0.65;
    // that.columns = that.columnsList;

    that.getMeterArray();
    that.getAddressEnum();
    that.generateColumnTitleArray();
    that.getMeterDetailedList();
    // that.selectMeterType = localStorage.getItem('userMeterType');
    that.modalData.timeRange[0] = global.dateFtt("yyyy-MM-dd", new Date());
    that.modalData.timeRange[1] = global.dateFtt("yyyy-MM-dd", new Date());

    var cs = [];
    if (localStorage.getItem("userMeterType") == 0) {
      cs = [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "用户编号",
          key: "用户编号",
          resizable: true,
          width: 160
        },
        {
          title: "用户姓名",
          key: "用户姓名",
          resizable: true,
          width: 160
        },
        {
          title: "安装地址",
          key: "安装地址",
          resizable: true,
          width: 300
        },
        {
          title: "表具类型",
          key: "表具类型",
          resizable: true,
          width: 160
        },
        {
          title: "表具地址",
          key: "message_address1",
          resizable: true,
          width: 160
        },
        {
          title: "口径",
          key: "口径",
          resizable: true,
          width: 160
        },
        {
          title: "上次抄表时间",
          key: "message_timestamp",
          resizable: true,
          width: 200
        },
        {
          title: "上次正向流量值",
          key: "上次正向流量值",
          resizable: true,
          width: 160
        },
        {
          title: "上次反向流量值",
          key: "上次反向流量值",
          resizable: true,
          width: 160
        },
        {
          title: "本次抄表时间",
          key: "message_timestamp1",
          resizable: true,
          width: 200
        },
        {
          title: "正向流量值",
          key: "正向流量值",
          resizable: true,
          width: 160
        },
        {
          title: "反向流量值",
          key: "反向流量值",
          resizable: true,
          width: 160
        },
        {
          title: "正向流量间隔值",
          key: "正向流量间隔值",
          resizable: true,
          width: 160
        },
        {
          title: "反向流量间隔值",
          key: "反向流量间隔值",
          resizable: true,
          width: 160
        }
      ];
    }

    if (localStorage.getItem("userMeterType") == 1) {
      cs = [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "用户编号",
          key: "用户编号",
          resizable: true,
          width: 160
        },
        {
          title: "用户姓名",
          key: "用户姓名",
          resizable: true,
          width: 160
        },
        {
          title: "安装地址",
          key: "安装地址",
          resizable: true,
          width: 300
        },
        {
          title: "表具类型",
          key: "表具类型",
          resizable: true,
          width: 160
        },
        {
          title: "表具地址",
          key: "message_address1",
          resizable: true,
          width: 160
        },
        {
          title: "口径",
          key: "口径",
          resizable: true,
          width: 160
        },
        {
          title: "上次抄表时间",
          key: "message_timestamp",
          resizable: true,
          width: 200
        },
        {
          title: "上次热量值",
          key: "上次热量值",
          resizable: true,
          width: 160
        },
        {
          title: "上次冷量值",
          key: "上次冷量值",
          resizable: true,
          width: 160
        },
        {
          title: "上次流量值",
          key: "上次流量值",
          resizable: true,
          width: 160
        },
        {
          title: "本次抄表时间",
          key: "message_timestamp1",
          resizable: true,
          width: 200
        },
        {
          title: "热量值",
          key: "热量值",
          resizable: true,
          width: 160
        },
        {
          title: "冷量值",
          key: "冷量值",
          resizable: true,
          width: 160
        },
        {
          title: "流量值",
          key: "流量值",
          resizable: true,
          width: 160
        },
        {
          title: "热量间隔值",
          key: "热量间隔值",
          resizable: true,
          width: 160
        },
        {
          title: "冷量间隔值",
          key: "冷量间隔值",
          resizable: true,
          width: 160
        },
        {
          title: "流量间隔值",
          key: "流量间隔值",
          resizable: true,
          width: 160
        }
      ];
    }

    if (localStorage.getItem("userMeterType") == 5) {
      cs = [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "用户编号",
          key: "用户编号",
          resizable: true,
          width: 160
        },
        {
          title: "用户姓名",
          key: "用户姓名",
          resizable: true,
          width: 160
        },
        {
          title: "安装地址",
          key: "安装地址",
          resizable: true,
          width: 200
        },
        {
          title: "表具类型",
          key: "表具类型",
          resizable: true,
          width: 160
        },
        {
          title: "表具地址",
          key: "message_address1",
          resizable: true,
          width: 160
        },
        {
          title: "口径",
          key: "口径",
          resizable: true,
          width: 160
        },
        {
          title: "上次抄表时间",
          key: "message_timestamp",
          resizable: true,
          width: 200
        },
        {
          title: "上次流量值",
          key: "上次流量值",
          resizable: true,
          width: 160
        },
        {
          title: "本次抄表时间",
          key: "message_timestamp1",
          resizable: true,
          width: 200
        },
        {
          title: "流量值",
          key: "流量值",
          resizable: true,
          width: 160
        },
        {
          title: "流量间隔值",
          key: "流量间隔值",
          resizable: true,
          width: 160
        }
      ];
    }

    that.columns = cs;
    that.columnsbackup = cs;
  },
  data() {
    return {
      pageName: "settlement",
      meterInfo: {},
      meterAddressName: {},
      isShowSetModal: false,
      addressObject: {},
      addressfield1: "",
      addressfield2: "",
      addressfield3: "",
      addressfield4: "",
      addressfield5: "",
      consumerNumber: "",
      consumerName: "",
      consumerPhone: "",
      tableHeight: 200,
      selectMeterType: 0,
      okLoading: false,
      hourList: [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23"
      ],
      meterTList: [
        {
          value: 0,
          label: "水表"
        },
        {
          value: 1,
          label: "热表"
        },
        {
          value: 2,
          label: "流量表"
        }
      ],
      userMeterTypeEnum: {
        "0": "水表",
        "5": "流量计",
        "1": "热量表",
        "2": "动态平衡阀",
        "3": "消防栓",
        "4": "压力开关、流量开关"
      },
      showOrder: ["0", "5"],
      meterType: "",
      modalData: {
        timeRange: ["2020-01-15", "2020-01-15"],
        hourRange: ["0", "23"],
        address: ""
      },
      columns: [],
      showColumnTitleArray: [],
      columnsbackup: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "用户编号",
          key: "用户编号",
          resizable: true,
          width: 160
        },
        {
          title: "用户姓名",
          key: "用户姓名",
          resizable: true,
          width: 160
        },
        {
          title: "安装地址",
          key: "安装地址",
          resizable: true,
          width: 200
        },
        {
          title: "表具类型",
          key: "表具类型",
          resizable: true,
          width: 160
        },
        {
          title: "表具地址",
          key: "message_address1",
          resizable: true,
          width: 160
        },
        {
          title: "口径",
          key: "口径",
          resizable: true,
          width: 160
        },
        {
          title: "上次抄表时间",
          key: "message_timestamp",
          resizable: true,
          width: 200
        },
        {
          title: "上次正向流量值",
          key: "上次正向流量值",
          resizable: true,
          width: 160
        },
        {
          title: "上次反向流量值",
          key: "上次反向流量值",
          resizable: true,
          width: 160
        },
        {
          title: "本次抄表时间",
          key: "message_timestamp1",
          resizable: true,
          width: 200
        },
        {
          title: "正向流量值",
          key: "正向流量值",
          resizable: true,
          width: 160
        },
        {
          title: "反向流量值",
          key: "反向流量值",
          resizable: true,
          width: 160
        },
        {
          title: "正向流量间隔值",
          key: "正向流量间隔值",
          resizable: true,
          width: 160
        },
        {
          title: "反向流量间隔值",
          key: "反向流量间隔值",
          resizable: true,
          width: 160
        }
      ],
      columnsList: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "用户编号",
          key: "用户编号",
          resizable: true,
          width: 160
        },
        {
          title: "用户姓名",
          key: "用户姓名",
          resizable: true,
          width: 160
        },
        {
          title: "安装地址",
          key: "安装地址",
          resizable: true,
          width: 200
        },
        {
          title: "表具类型",
          key: "表具类型",
          resizable: true,
          width: 160
        },
        {
          title: "表具地址",
          key: "message_address1",
          resizable: true,
          width: 160
        },
        {
          title: "口径",
          key: "口径",
          resizable: true,
          width: 160
        },
        {
          title: "上次抄表时间",
          key: "message_timestamp",
          resizable: true,
          width: 200
        },
        {
          title: "上次正向流量值",
          key: "上次正向流量值",
          resizable: true,
          width: 160
        },
        {
          title: "上次反向流量值",
          key: "上次反向流量值",
          resizable: true,
          width: 160
        },
        {
          title: "本次抄表时间",
          key: "message_timestamp1",
          resizable: true,
          width: 200
        },
        {
          title: "正向流量值",
          key: "正向流量值",
          resizable: true,
          width: 160
        },
        {
          title: "反向流量值",
          key: "反向流量值",
          resizable: true,
          width: 160
        },
        {
          title: "正向流量间隔值",
          key: "正向流量间隔值",
          resizable: true,
          width: 160
        },
        {
          title: "反向流量间隔值",
          key: "反向流量间隔值",
          resizable: true,
          width: 160
        }
      ],
      tableData: [],
      meterArray: []
    };
  },
  methods: {
    exportTable() {
      this.$refs.table.exportCsv({
        filename: "结算数据",
        original: false
      });
    },
    changeColumn(checked, name) {
      if (checked) {
        this.showColumnTitleArray.push(name);
      } else {
        this.showColumnTitleArray.splice(
          this.showColumnTitleArray.indexOf(name),
          1
        );
      }

      var showArray = [];

      for (let i = 0; i < this.columnsbackup.length; i++) {
        let currentObject = this.columnsbackup[i];
        if (this.showColumnTitleArray.indexOf(currentObject.title) > -1) {
          showArray.push(currentObject);
        }
      }

      localStorage.setItem(
        this.pageName +
          localStorage.getItem("userAccount") +
          localStorage.getItem("userMeterType"),
        JSON.stringify(this.showColumnTitleArray)
      );

      this.columns = showArray;

      if (
        localStorage.getItem(
          this.pageName +
            localStorage.getItem("userAccount") +
            localStorage.getItem("userMeterType")
        ) != undefined
      ) {
        this.showColumnTitleArray = JSON.parse(
          localStorage.getItem(
            this.pageName +
              localStorage.getItem("userAccount") +
              localStorage.getItem("userMeterType")
          )
        );
        var showArray = [];
        for (let i = 0; i < this.columnsbackup.length; i++) {
          let currentObject = this.columnsbackup[i];
          if (this.showColumnTitleArray.indexOf(currentObject.title) > -1) {
            showArray.push(currentObject);
          }
        }

        this.columns = showArray;
      }
    },
    generateColumnTitleArray() {
      let titleArray = [];

      for (let i = 0; i < this.columnsbackup.length; i++) {
        titleArray.push(this.columnsbackup[i].title);
      }

      this.showColumnTitleArray = titleArray;
      console.log(this.showColumnTitleArray);
    },
    getAddressEnum() {
      var that = this;
      that.$axios
        .post("/api/dictionary/selectAddressEnum", {})
        .then(data => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.addressObject = data.body;
          that.addressObject.addressfield5.sort(function(a, b) {
            return (
              a.name.replace("号", "").replace("-", "") -
              b.name.replace("号", "").replace("-", "")
            );
          });
          console.log(23132132);
          console.log(data.body);
        })
        .catch(error => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        })
        .finally(() => {});
    },
    async getMeterArray() {
      var that = this;
      that.$axios
        .post("/api/meter/selectMeterList", {
          addressfield1: that.addressfield1,
          addressfield2: that.addressfield2,
          addressfield3: that.addressfield3,
          addressfield4: that.addressfield4,
          addressfield5: that.addressfield5
        })
        .then(data => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.meterArray = data.body;
          for (let i = 0; i < that.meterArray.length; i++) {
            that.meterInfo[that.meterArray[i].meterAddress] =
              that.meterArray[i];
          }
          console.log(data.body);
        })
        .catch(error => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        })
        .finally(() => {});
    },
    getUserMeterType() {
      return global.searchMeterType();
    },
    getMeterDetailedList() {
      var that = this;
      that.$axios
        .post("/api/meterdetailed/getMeterDetailedList", {
          userAccount: localStorage.getItem("userAccount")
        })
        .then(data => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.meterAddressName = {};

          data.body.forEach(item => {
            let indexList = [0];
            item.id = item.meterAddress;
            item.title = item.meterAddress;
            let addressNameTemp = "";
            for (let i = 1; i <= 10; i++) {
              if (item["addressfield" + i + "Name"]) {
                console.log(item);
                addressNameTemp =
                  (addressNameTemp == "" ? "" : addressNameTemp + "-") +
                  item["addressfield" + i + "Name"];
              }
            }
            that.meterAddressName[item.meterAddress] = addressNameTemp;
            that.meterInfo[item.meterAddress] = item;
          });
        })
        .catch(error => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        })
        .finally(() => {});
    },
    ok() {
      let resultList = [];
      if (
        this.modalData.timeRange[0] &&
        this.modalData.timeRange[1] &&
        this.modalData.hourRange[0] &&
        this.modalData.hourRange[1]
      ) {
        let dateStart = new Date(this.modalData.timeRange[0]);
        dateStart.setHours(this.modalData.hourRange[0] * 1);
        let dateEnd = new Date(this.modalData.timeRange[1]);
        dateEnd.setHours(this.modalData.hourRange[1] * 1);
        if (dateEnd.getTime() - dateStart.getTime() <= 0) {
          this.$Notice.warning({
            title: "开始时间必须小于结束时间！"
          });
        } else {
          this.okLoading = true;
          let that = this;
          var searchParam = {
            addressfield1: that.addressfield1,
            addressfield2: that.addressfield2,
            addressfield3: that.addressfield3,
            addressfield4: that.addressfield4,
            addressfield5: that.addressfield5,
            address: that.modalData.address,
            startDate: dateStart,
            endDate: dateEnd,
            consumerNumber: that.consumerNumber,
            consumerName: that.consumerName,
            consumerPhone: that.consumerPhone,
            meterType:
              that.meterType != "" && that.meterType != undefined
                ? that.userMeterTypeEnum[that.meterType]
                : ""
          };
          var searchMeterType = global.searchMeterType();
          if (searchMeterType != undefined) {
            searchParam.meterType = searchMeterType;
          }
          that.tableData = [];
          that.$axios
            .post("/api/message/settlementList", searchParam)
            .then(data => {
              if (data.errorCode != 0) {
                that.$Notice.error({
                  title: "异常",
                  desc: data.errorInfo
                });
                return;
              }
              that.tableData = [];
              console.log(data.body);
              data.body.map(item => {
                console.log(item);

                item["安装地址"] = that.meterAddressName[item.message_address1];
                item["表具类型"] =
                  that.meterInfo[item.message_address1].meterType;
                item["用户编号"] =
                  that.meterInfo[item.message_address1].consumerNumber;
                item["用户姓名"] =
                  that.meterInfo[item.message_address1].consumerName;
                item["口径"] =
                  that.meterInfo[item.message_address1].meterCaliber;

                item.message_timestamp =
                  item.message_timestamp == undefined
                    ? ""
                    : global.dateFtt(
                        "yyyy-MM-dd hh:mm:ss",
                        new Date(item.message_timestamp)
                      );
                item.message_timestamp1 =
                  item.message_timestamp1 == undefined
                    ? ""
                    : global.dateFtt(
                        "yyyy-MM-dd hh:mm:ss",
                        new Date(item.message_timestamp1)
                      );
                item.message_address1 = "\t" + item.message_address1;
                let content = null;
                if (item.message_content) {
                  content = JSON.parse(item.message_content).decode.paramArray;
                  // item["上次正向流量值"] = content["正向流量值"].value;
                  // item["上次反向流量值"] = content["反向流量值"].value;
                  item["上次正向流量值"] =
                    content["正向流量值"].value == undefined
                      ? ""
                      : Math.round(
                          (parseFloat(content["正向流量值"].value) / 1000) * 100
                        ) / 100;
                  item["上次反向流量值"] =
                    content["反向流量值"].value == undefined
                      ? ""
                      : Math.round(
                          (parseFloat(content["反向流量值"].value) / 1000) * 100
                        ) / 100;

                  item["上次热量值"] = content["热量值"].value;
                  item["上次冷量值"] = content["冷量值"].value;
                  item["上次流量值"] = content["正向流量值"].value;
                }
                let content1 = JSON.parse(item.message_content1).decode
                  .paramArray;
                item["正向流量值"] =
                  content1["正向流量值"].value == undefined
                    ? ""
                    : Math.round(
                        (parseFloat(content1["正向流量值"].value) / 1000) * 100
                      ) / 100;
                item["反向流量值"] =
                  content1["反向流量值"].value == undefined
                    ? ""
                    : Math.round(
                        (parseFloat(content1["反向流量值"].value) / 1000) * 100
                      ) / 100;

                item["热量值"] = content1["热量值"].value;
                item["冷量值"] = content1["冷量值"].value;
                item["流量值"] = content1["正向流量值"].value;
                if (content) {
                  // item["正向流量间隔值"] = content1["正向流量值"].value - content["正向流量值"].value;
                  // item["反向流量间隔值"] = content1["反向流量值"].value - content["反向流量值"].value;
                  item["正向流量间隔值"] =
                    item["正向流量值"] - item["上次正向流量值"];
                  item["反向流量间隔值"] =
                    item["反向流量值"] - item["上次反向流量值"];
                  item["热量间隔值"] =
                    content1["热量值"].value - content["热量值"].value;
                  item["冷量间隔值"] =
                    content1["冷量值"].value - content["冷量值"].value;
                  item["流量间隔值"] =
                    content1["正向流量值"].value - content["正向流量值"].value;
                } else {
                  // item["正向流量间隔值"] = content1["正向流量值"].value;
                  // item["反向流量间隔值"] = content1["反向流量值"].value;
                  item["正向流量间隔值"] = item["正向流量值"];
                  item["反向流量间隔值"] = item["反向流量值"];
                  item["热量间隔值"] = content1["热量值"].value;
                  item["冷量间隔值"] = content1["冷量值"].value;
                  item["流量间隔值"] = content1["正向流量值"].value;
                }

                item["正向流量间隔值"] = (item["正向流量间隔值"]/1000).toFixed(2);
                item["反向流量间隔值"] = (item["反向流量间隔值"]/1000).toFixed(2);
                item["热量间隔值"] = item["热量间隔值"].toFixed(2);
                item["冷量间隔值"] = item["冷量间隔值"].toFixed(2);
                item["流量间隔值"] = (item["流量间隔值"]/1000).toFixed(2);
                item["流量值"] = (item["流量值"]/1000).toFixed(2);
                item["上次流量值"] = (item["上次流量值"]/1000).toFixed(2);

                item["正向流量间隔值"] += " m³";
                item["反向流量间隔值"] += " m³";
                item["热量间隔值"] += " kWh";
                item["冷量间隔值"] += " kWh";
                item["流量间隔值"] += " m³";
                item["热量值"] += " kWh";
                item["冷量值"] += " kWh";
                item["流量值"] += " m³";
                item["上次热量值"] += " kWh";
                item["上次冷量值"] += " kWh";
                item["上次流量值"] += " m³";

                if(item["正向流量值"] != undefined){
                  item["正向流量值"] += " m³";
                }
                if(item["反向流量值"]  != undefined){
                  item["反向流量值"] += " m³";
                }
                if(item["上次正向流量值"]  != undefined){
                  item["上次正向流量值"] += " m³";
                }
                if(item["上次反向流量值"]  != undefined){
                  item["上次反向流量值"] += " m³";
                }

                item["message_timestamp"] = "\t" + item["message_timestamp"];
                item["message_timestamp1"] = "\t" + item["message_timestamp1"];
                that.tableData.push(item);
              });
              // let lastContent = null;
              // let lastId = null;
              // that.tableData = [];
              // data.body.map((item) => {
              //   item.message_timestamp = global.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(item.message_timestamp));
              //   let content = JSON.parse(item.message_content).decode.paramArray;
              //   item["正向流量值"] = content["正向流量值"].value;
              //   item["反向流量值"] = content["反向流量值"].value;
              //   item["热量值"] = content["热量值"].value;
              //   item["冷量值"] = content["冷量值"].value;
              //   item["流量值"] = content["正向流量值"].value;
              //   if (lastContent) {
              //     console.log(lastContent);
              //     item["正向流量间隔值"] = content["正向流量值"].value - lastContent["正向流量值"].value;
              //     item["反向流量间隔值"] = content["反向流量值"].value - lastContent["反向流量值"].value;
              //     item["热量间隔值"] = content["热量值"].value - lastContent["热量值"].value;
              //     item["冷量间隔值"] = content["冷量值"].value - lastContent["冷量值"].value;
              //     item["流量间隔值"] = content["正向流量值"].value - lastContent["正向流量值"].value;
              //   } else {
              //     item["正向流量间隔值"] = content["正向流量值"].value;
              //     item["反向流量间隔值"] = content["反向流量值"].value;
              //     item["热量间隔值"] = content["热量值"].value;
              //     item["冷量间隔值"] = content["冷量值"].value;
              //     item["流量间隔值"] = content["正向流量值"].value;
              //   }
              //   lastContent = JSON.parse(item.message_content).decode.paramArray;
              //   if (lastId != item.message_id) {
              //     that.tableData.push(item);
              //   }
              //   lastId = item.message_id;
              //   return item;
              // });
              console.log(data.body);
            })
            .catch(error => {
              that.$Notice.error({
                title: "异常",
                desc: error
              });
              console.log(error);
            })
            .finally(() => {
              that.okLoading = false;
            });
        }
      }
    }
  }
};
</script>

<style scoped>
.settlement-container {
  padding-top: 5px;
  height: 100%;
}

.settlement-content {
  height: 100%;
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}

.min-table /deep/ .ivu-table td {
  height: 0px;
}

.min-table /deep/ .ivu-table-header thead tr th {
  height: 0px;
  padding: 0px;
}
</style>
